import { Injectable } from '@angular/core';
import { BaseService } from './base-service.service';
import { PaymentModel } from '../models/payment.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends BaseService<PaymentModel> {
  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}api/payment`);
  }
}
